import { render, staticRenderFns } from "./WallpaperBig.vue?vue&type=template&id=5b7a3094"
import script from "./WallpaperBig.vue?vue&type=script&lang=js"
export * from "./WallpaperBig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports